<template>
    <section id="beneficios" class="sp-section sp-section--alt sp-beneficios-section">
        <!-- Orbe de luz ambiental -->
        <div class="sp-glow-orb sp-glow-orb--navy" style="top: 20%; left: -5%; width: 400px; height: 400px;"></div>

        <div class="sp-container">
            <div class="sp-section-head sp-reveal">
                <span class="sp-eyebrow">Beneficios para tu negocio</span>
                <h2 class="sp-h2">Más visibilidad, más clientes en ruta</h2>
                <p class="sp-lead">
                    Conecta tu negocio con conductores de carga que pasan cerca de tu
                    establecimiento en el momento exacto en que necesitan tus servicios.
                </p>
            </div>

            <ul class="sp-beneficios">
                <li v-for="(b, idx) in beneficios" :key="b.titulo" class="sp-reveal" :class="'sp-delay-' + (idx + 1)">
                    <article class="sp-card sp-beneficio">
                        <div class="sp-beneficio__glow-line"></div>
                        <span class="sp-icon-badge">
                            <i :class="'pi ' + b.icon" aria-hidden="true"></i>
                        </span>
                        <h3 class="sp-h3">{{ b.titulo }}</h3>
                        <p>{{ b.texto }}</p>
                    </article>
                </li>
            </ul>
        </div>
    </section>
</template>

<script>
export default {
    name: 'NegociosBeneficios',
    data() {
        return {
            beneficios: [
                {
                    icon: 'pi-user-plus',
                    titulo: 'Llega al público correcto',
                    texto: 'Conecta con conductores de carga pesada que pasan cerca de tu negocio y toman decisiones de compra en ruta.'
                },
                {
                    icon: 'pi-map-marker',
                    titulo: 'Publicidad geolocalizada',
                    texto: 'Tu oferta puede aparecer cuando el conductor se acerca a tu establecimiento dentro del área de cobertura.'
                },
                {
                    icon: 'pi-megaphone',
                    titulo: 'Promociona tus ofertas',
                    texto: 'Destaca descuentos especiales, combos de almuerzo, hospedaje 24h, talleres mecánicos y mucho más.'
                },
                {
                    icon: 'pi-chart-bar',
                    titulo: 'Mide tus resultados',
                    texto: 'Consulta en tiempo real el rendimiento de tus campañas, impresiones y el interés generado en tu zona.'
                }
            ]
        };
    }
};
</script>

<style lang="scss" scoped>
.sp-beneficios-section {
    position: relative;
    overflow: hidden;
}

.sp-beneficios {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1.5rem;
}

.sp-beneficio {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    background: #ffffff;
    border-radius: var(--sp-radius-lg);
    border: 1px solid var(--sp-border);
    padding: clamp(1.6rem, 3vw, 2.25rem);
    transition: transform var(--sp-transition-normal), box-shadow var(--sp-transition-normal), border-color var(--sp-transition-normal);

    &:hover {
        transform: translateY(-8px);
        border-color: rgba(235, 93, 27, 0.4);
        box-shadow: 0 18px 40px rgba(13, 48, 68, 0.12);

        .sp-beneficio__glow-line {
            opacity: 1;
            transform: scaleX(1);
        }

        .sp-icon-badge {
            transform: scale(1.1) rotate(4deg);
            background: linear-gradient(135deg, var(--sp-orange) 0%, var(--sp-orange-600) 100%);
            color: #fff;
            box-shadow: 0 8px 20px rgba(235, 93, 27, 0.35);
        }
    }

    p {
        color: var(--sp-text-soft);
        font-size: 0.96rem;
        line-height: 1.6;
    }
}

.sp-beneficio__glow-line {
    position: absolute;
    top: 0;
    left: 10%;
    right: 10%;
    height: 3px;
    background: linear-gradient(90deg, transparent, var(--sp-orange), transparent);
    border-radius: 999px;
    opacity: 0;
    transform: scaleX(0.5);
    transition: opacity 0.3s ease, transform 0.3s ease;
}

@media (min-width: 576px) {
    .sp-beneficios {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (min-width: 1200px) {
    .sp-beneficios {
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }
}
</style>
